import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;
const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN;

const parseStrapiResponse = (data) => {
  const translations = {};
  try {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    if (Array.isArray(parsed.data)) {
      parsed.data.forEach(({ key, value }) => {
        if (key && value) {
          translations[key] = value;
        }
      });
    }
  } catch (error) {
    console.error('❌ Failed to parse Strapi translations:', error);
  }
  return translations;
};

// Optional: add timestamp to bust cache during development
const timestamp = process.env.NODE_ENV === 'development' ? `&t=${Date.now()}` : '';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'it'],
    nonExplicitSupportedLngs: true,
    debug: false,

    detection: {
      order: ['cookie', 'navigator'],
      caches: ['cookie'],
    },

    backend: {
      loadPath: `${STRAPI_URL}/api/translation-strings?locale={{lng}}&pagination[pageSize]=200${timestamp}`,
      requestOptions: {
        headers: {
          Authorization: `Bearer ${STRAPI_TOKEN}`,
          'Cache-Control': 'no-cache',
        },
      },
      parse: parseStrapiResponse,
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },

    returnNull: false,
    returnEmptyString: false,
    returnObjects: true,
  });

export default i18n;
